import {Component} from '@angular/core';
import {BusinessAdComponent} from "./business.component";

@Component({
  selector: 'sol-ads',
  standalone: true,
  template: `
    <sol-ads-business />
  `,
  styles: ``,
  imports: [
    BusinessAdComponent
  ]
})
export class AdsComponent {
}
